const doc = [({"da":({"js":({"admin":({"user_elements":({"edit":({"update_answer":"Opdatér besvarelse", "the_answer_was_updated":"Svaret blev opdateret"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;